import { ConfirmationPage } from "./ConfirmationPage";
import { OfferPage } from "./OfferPage";

export const Title = {
  OfferPage,
  ConfirmationPage,
};
